interface SelectAProfessionDisclaimerProps {
	disclaimer?: string;
	isDisclaimerAccepted: boolean;
	setIsDisclaimerAccepted: (isDisclaimerAccepted: boolean) => void;
	text?: string;
}

const SelectAProfessionDisclaimer = ({
	disclaimer,
	isDisclaimerAccepted,
	setIsDisclaimerAccepted,
	text,
}: SelectAProfessionDisclaimerProps) => {
	return (
		<div className="-mt-2 phablet:-mt-4 flex flex-col gap-2">
			<label htmlFor="disclaimer" className="flex flex-col gap-2.5 text-xs">
				{disclaimer && (
					<span className="block">
						<strong>Note:</strong> {disclaimer}
					</span>
				)}

				<div className="flex gap-2">
					<input
						id="disclaimer"
						name="disclaimer"
						type="checkbox"
						checked={isDisclaimerAccepted}
						onChange={() => setIsDisclaimerAccepted(!isDisclaimerAccepted)}
						className="checkbox size-5 checked:bg-sky-500 checked:text-white"
					/>
					<span className="text-base">{text ? text : "I Accept"}</span>
				</div>
			</label>
		</div>
	);
};

export default SelectAProfessionDisclaimer;
